import React, { useContext} from 'react';
import { IProps } from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import Tooltip from '@components/Tooltip';
import { isLockedElement } from '@utils/editor';
import { LockedIcon } from '@assets/icons/lockedIcon';
import { UnlockedIcon } from '@assets/icons/unlockedIcon';

const LockUnlockCommandOption : React.FC<IProps> = () => {
  let { onCommandChange, data, editorStatus} = useContext(Context);
  const locked = isLockedElement(editorStatus.selectedElementsId, data);
  
  return (    
    <S.Root>
      <Tooltip tip={locked ? "Unlock" : "Lock"}>
        <S.ButtonContainer onClick={()=> { onCommandChange("lockUnlockElement", locked!==undefined ? !locked : true) }}>
        {locked ? <LockedIcon/>: <UnlockedIcon/>}
        </S.ButtonContainer>
      </Tooltip>
    </S.Root>
  );
}

export default LockUnlockCommandOption;